export enum NotificationAuthorityType {
  Single = 'single', Group = 'group'
}


export interface NotificationAuthority {
  type: NotificationAuthorityType;
  value: string;
}

export interface NotificationBase {
  _id?: string;
  domain: string;
  action?: string;
  authorities?: NotificationAuthority[];
  content: any;
  metadata?: any;
  createdAt?: Date;
  seen?: boolean;
}

export {NotificationBase as  Notification};
